<template>
  <router-view name="banner" v-bind:key="$route.path"></router-view>
</template>
<script>
export default {
  name: "Banner",
};
</script>
